import axios from "axios";
import { BASE_URL, LOCAL_STORAGE_KEY } from "./config";
export const API = {
  login,
  getExcoPusat,
  getExcoDocument,
  uploadDocument,
  deleteDocument,
  downloadDocument,
  downloadHistoryDocument,
  listHistoryDocument,
  getDetailExcoPusat,
  getProvince,
  getKabKot,
  getKecamatan,
  getKelurahan,
  getTingkatExco,
  getJabatan,
  patchAddressOffice,
  getProfile,
  changePassword,
  changePhoneNumber,
  getTableExco,
  getUsers,
  getUserManagement,
  patchUserManagement,
  addNewUser,
  changePasswordUser,
  getDetailTableExco,
  getAnggota,
  postPengurus,
  patchPengurus,
  deletePengurus,
  getDetailPengurus,
  getTrendAnggota,
  getPengurusProvinsi,
  getPengurusKabkot,
  getPengurusKecamatan,
  getOverviewPengurus,
  getAnggotaOverview,
  getAnggotaProvinsi,
  getAnggotaKabkot,
  getAnggotaKecamatan,
  getDokumenProvinsi,
  getDokumenKabkot,
  getDokumenKecamatan,
  getJumlahPusatOverview,
  getJumlahProvinsiOverview,
  getJumlahKabkotOverview,
  getJumlahKecamatanOverview,
  getDaftarAnggota,
  lockUnlockExco,
  getHakAkses,
  updateHakAkses,
  getDownloadPengurusPusat,
  getDownloadPengurusProvinsi,
  getDownloadPengurusKabkot,
  getDownloadPengurusKecamatan,
  getDownloadRekapPengurusPusat,
  getDownloadRekapPengurusProvinsi,
  getDownloadRekapPengurusKabkot,
  getDownloadRekapAnggota,
  getDownloadDaftarAnggota,
  getBank,
  getOverviewProvinsi,
  getOverviewKabkot,
  getOverviewKecamatan,
  getOverviewKelurahan,
  getOverviewRtRw,
  getOverviewKomisarisBasis,
  uploadDocumentPengurus,
  deleteDocumentPengurus,
  downloadDocumentPengurus,
  getExcoRTRW,
  getExcoPUK,
  createExcoPUK,
  createExcoRTRW,
  getCatatan,
};

const defaultHeaders = {
  "Content-Type": "application/json",
};

const loadAuthToken = () => {
  let result = null;
  const storedCreds = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  result = storedCreds && storedCreds.token;

  return result;
};

// auth login
async function login(data) {
  try {
    const url = `${BASE_URL}/auth/login`;
    const headers = defaultHeaders;
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get exco rt rw
async function getExcoRTRW(params) {
  try {
    const url = `${BASE_URL}/kantor/rt-rw`;
    const headers = {
      ...defaultHeaders,
      Authorization: `Bearer ${loadAuthToken()}`,
    };
    const response = await axios({
      method: "GET",
      url,
      params,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// EXCO PUSAT
async function getExcoPusat() {
  try {
    const url = `${BASE_URL}/kantor/pusat`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// EXCO DOCUMENT
async function getExcoDocument(id) {
  try {
    const url = `${BASE_URL}/dokumen/get-all/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// UPLOAD DOCUMENT
async function uploadDocument(data) {
  try {
    const url = `${BASE_URL}/dokumen/upload`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DELETE DOCUMENT
async function deleteDocument(id) {
  try {
    const url = `${BASE_URL}/dokumen/delete/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "DELETE",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DOWNLOAD DOCUMENT
async function downloadDocument(id) {
  try {
    const url = `${BASE_URL}/dokumen/download/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DOWNLOAD History DOCUMENT
async function downloadHistoryDocument(id) {
  try {
    const url = `${BASE_URL}/dokumen/history/download/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// list history DOCUMENT
async function listHistoryDocument(id_kantor, id_kategori_dokumen) {
  try {
    const url = `${BASE_URL}/dokumen/history/${id_kantor}/${id_kategori_dokumen}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDetailExcoPusat(idTingkatExco, idDaerah) {
  try {
    let param = "";
    if (idTingkatExco === 5 || idTingkatExco === "5") {
      param = "&id_kelurahan=" + idDaerah;
    } else if (idTingkatExco === 4 || idTingkatExco === "4") {
      param = "&id_kecamatan=" + idDaerah;
    } else if (idTingkatExco === 2 || idTingkatExco === "2") {
      param = "&id_provinsi=" + idDaerah;
    } else if (idTingkatExco === 3 || idTingkatExco === "3") {
      param = "&id_kabkot=" + idDaerah;
    } else if (idTingkatExco === 6 || idTingkatExco === "6") {
      param = "&id_kantor_exco=" + idDaerah;
    } else if (idTingkatExco === 7 || idTingkatExco === "7") {
      param = "&id_kantor_exco=" + idDaerah;
    }
    const url = `${BASE_URL}/kantor/detail?id_tingkat_exco=${idTingkatExco}${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
// get province
async function getProvince() {
  try {
    const url = `${BASE_URL}/wilayah/provinsi`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
// get kabkot
async function getKabKot(id) {
  try {
    const url = `${BASE_URL}/wilayah/kota-kabupaten?provinsi=${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get kecamtan
async function getKecamatan(param) {
  try {
    const url = `${BASE_URL}/wilayah/kecamatan?${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get kelurahan
async function getKelurahan(param) {
  try {
    const url = `${BASE_URL}/wilayah/kelurahan?${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get /tingkat-exco
async function getTingkatExco() {
  try {
    const url = `${BASE_URL}/wilayah/tingkat-exco`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get jabatan
async function getJabatan(param) {
  try {
    const url = `${BASE_URL}/wilayah/jabatan?id_tingkat_exco=${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get catatan
async function getCatatan() {
  try {
    const url = `${BASE_URL}/pengurus/master-catatan`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
// edit alamat kantor
async function patchAddressOffice(id, data) {
  try {
    const url = `${BASE_URL}/kantor/update/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "PATCH",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get profile
async function getProfile() {
  try {
    const url = `${BASE_URL}/auth/profile`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// change password
async function changePassword(data) {
  // console.log(`changePassword data`, data);
  try {
    const url = `${BASE_URL}/auth/update-password`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
// change phoneNumber
async function changePhoneNumber(data) {
  // console.log(`changePhoneNumber =======>`, data);
  try {
    const url = `${BASE_URL}/auth/update-phone`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,

      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
// getTableExco
async function getTableExco(
  param,
  page,
  search,
  sort,
  sortType,
  filterProv,
  filterKabkot,
  filterKec,
) {
  try {
    let params = "";
    if (search) {
      params = params + `&search=${search}`;
    }
    if (sort) {
      params = params + `&order_by=${sort}`;
    }
    if (sortType) {
      params = params + `&order_type=${sortType}`;
    }
    if (filterProv && filterProv !== "0") {
      params = params + `&id_provinsi=${filterProv}`;
    }
    if (filterKabkot && filterKabkot !== "0") {
      params = params + `&id_kabkot=${filterKabkot}`;
    }
    if (filterKec && filterKec !== "0") {
      params = params + `&id_kecamatan=${filterKec}`;
    }
    const url = `${BASE_URL}/kantor/${param}?page=${page}${params}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// getTableExco
async function getUsers(page, search, sortBy, sortType, filterLevel) {
  try {
    let param = `page=${page}`;
    if (search) {
      param = param + `&search=${search}`;
    }
    if (sortBy) {
      param = param + `&order_by=${sortBy}`;
    }
    if (sortType) {
      param = param + `&order_type=${sortType}`;
    }
    if (filterLevel && filterLevel !== "") {
      param = param + `&id_tingkat_exco=${filterLevel}`;
    }
    const url = `${BASE_URL}/auth/get-users?${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get detail users
async function getUserManagement(param) {
  try {
    const url = `${BASE_URL}/auth/get/${param}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// put/patch detail users
async function patchUserManagement(id, data) {
  try {
    const url = `${BASE_URL}/auth/update-user/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// CHANGE PASSWORD USER
async function changePasswordUser(data) {
  try {
    const url = `${BASE_URL}/auth/exco/update-password`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// CHANGE PASSWORD USER
async function addNewUser(data) {
  try {
    const url = `${BASE_URL}/auth/create`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// GET TABLE DETAIL EXCO
async function getDetailTableExco(id) {
  try {
    const url = `${BASE_URL}/pengurus/get-all/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// GET Anggota
async function getAnggota(search) {
  try {
    const url = `${BASE_URL}/wilayah/anggota?search=${search}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// POST Pengurus
async function postPengurus(data) {
  try {
    const url = `${BASE_URL}/pengurus/create`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// PATCH Pengurus
async function patchPengurus(id, data) {
  try {
    const url = `${BASE_URL}/pengurus/update/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "PATCH",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DELETE Pengurus
async function deletePengurus(id) {
  try {
    const url = `${BASE_URL}/pengurus/delete/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "DELETE",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get detail user table  Pengurus
async function getDetailPengurus(id) {
  try {
    const url = `${BASE_URL}/pengurus/get-detail/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getCompleteDocProvince() {
  try {
    const url = `${BASE_URL}/kantor/provinsi/jumlah-lengkap`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getCompleteDocCity(id) {
  try {
    const url = `${BASE_URL}/kantor/kota-kabupaten/jumlah-lengkap?provinsi=${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getCompleteDocKec(id_prov, id_kab_kot) {
  try {
    const url = `${BASE_URL}/kantor/kecamatan/jumlah-lengkap?provinsi=${id_prov}&id_kabkot=${id_kab_kot}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getTrendAnggota(tingkat_exco, id_daerah, tanggal, satuan) {
  try {
    const url = `${BASE_URL}/list-register/get-jumlah-anggota?id_tingkat_exco=${tingkat_exco}&id_daerah=${id_daerah}&tanggal=${tanggal}&satuan=${satuan}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getPengurusProvinsi(
  order_type,
  order_by,
  search,
  pemenuhan_kabkot,
  pemenuhan_pengurus_perempuan,
) {
  try {
    const url = `${BASE_URL}/pengurus/provinsi?order_type=${order_type}&order_by=${order_by}&search=${search}&pemenuhan_kabkot=${pemenuhan_kabkot}&pemenuhan_pengurus_perempuan=${pemenuhan_pengurus_perempuan}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getPengurusKabkot(
  order_type,
  order_by,
  search,
  id_provinsi,
  pemenuhan_kecamatan,
  pemenuhan_pengurus_perempuan,
) {
  try {
    const url = `${BASE_URL}/pengurus/kota-kabupaten?order_type=${order_type}&order_by=${order_by}&search=${search}&id_provinsi=${id_provinsi}&pemenuhan_kecamatan=${pemenuhan_kecamatan}&pemenuhan_pengurus_perempuan=${pemenuhan_pengurus_perempuan}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getPengurusKecamatan(
  order_type,
  order_by,
  search,
  id_kabkot,
  pemenuhan_pengurus_perempuan,
) {
  try {
    const url = `${BASE_URL}/pengurus/kecamatan?order_type=${order_type}&order_by=${order_by}&search=${search}&id_kabkot=${id_kabkot}&pemenuhan_pengurus_perempuan=${pemenuhan_pengurus_perempuan}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getOverviewPengurus(id_tingkat_exco, id_daerah) {
  try {
    const url = `${BASE_URL}/pengurus/count?id_tingkat_exco=${id_tingkat_exco}&id_daerah=${id_daerah}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getAnggotaOverview(id_tingkat_exco, id_daerah) {
  try {
    const url = `${BASE_URL}/list-register/jumlah-target-anggota-populasi?id_tingkat_exco=${id_tingkat_exco}&id_daerah=${id_daerah}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getAnggotaProvinsi(
  order_type,
  order_by,
  search,
  pemenuhan_target,
) {
  try {
    const url = `${BASE_URL}/list-register/provinsi/count?order_type=${order_type}&order_by=${order_by}&search=${search}&pemenuhan_target=${pemenuhan_target}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getAnggotaKabkot(
  order_type,
  order_by,
  search,
  id_provinsi,
  pemenuhan_target,
) {
  try {
    const url = `${BASE_URL}/list-register/kota-kabupaten/count?order_type=${order_type}&order_by=${order_by}&search=${search}&id_provinsi=${id_provinsi}&pemenuhan_target=${pemenuhan_target}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getAnggotaKecamatan(
  order_type,
  order_by,
  search,
  id_kabkot,
  pemenuhan_target,
) {
  try {
    const url = `${BASE_URL}/list-register/kecamatan/count?order_type=${order_type}&order_by=${order_by}&search=${search}&id_kabkot=${id_kabkot}&pemenuhan_target=${pemenuhan_target}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getJumlahPusatOverview() {
  try {
    const url = `${BASE_URL}/kantor/pusat/jumlah-lengkap`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getJumlahProvinsiOverview() {
  try {
    const url = `${BASE_URL}/kantor/provinsi/jumlah-lengkap`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getJumlahKabkotOverview() {
  try {
    const url = `${BASE_URL}/kantor/kota-kabupaten/jumlah-lengkap`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getJumlahKecamatanOverview() {
  try {
    const url = `${BASE_URL}/kantor/kecamatan/jumlah-lengkap`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDokumenProvinsi(
  order_type,
  order_by,
  search,
  pemenuhan_kabkot,
  kelengkapan_dokumen,
) {
  try {
    const url = `${BASE_URL}/kantor/provinsi/info-kelengkapan?order_type=${order_type}&order_by=${order_by}&search=${search}&pemenuhan_kabkot=${pemenuhan_kabkot}&kelengkapan_dokumen=${kelengkapan_dokumen}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDokumenKabkot(
  order_type,
  order_by,
  search,
  id_provinsi,
  pemenuhan_kecamatan,
  kelengkapan_dokumen,
) {
  try {
    const url = `${BASE_URL}/kantor/kota-kabupaten/info-kelengkapan?order_type=${order_type}&order_by=${order_by}&search=${search}&id_provinsi=${id_provinsi}&pemenuhan_kecamatan=${pemenuhan_kecamatan}&kelengkapan_dokumen=${kelengkapan_dokumen}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDokumenKecamatan(
  order_type,
  order_by,
  search,
  id_kabkot,
  kelengkapan_dokumen,
) {
  try {
    const url = `${BASE_URL}/kantor/kecamatan/info-kelengkapan?order_type=${order_type}&order_by=${order_by}&search=${search}&id_kabkot=${id_kabkot}&kelengkapan_dokumen=${kelengkapan_dokumen}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDaftarAnggota(
  order_type,
  order_by,
  page,
  size,
  search,
  id_tingkat_exco,
  id_daerah,
  jenis_kelamin,
  status_perkawinan,
) {
  try {
    const url = `${BASE_URL}/list-register/get-all?order_type=${order_type}&order_by=${order_by}&page=${page}&size=${size}&search=${search}&id_tingkat_exco=${id_tingkat_exco}&id_daerah=${id_daerah}&jenis_kelamin=${jenis_kelamin}&status_perkawinan=${status_perkawinan}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function lockUnlockExco(data) {
  try {
    const url = `${BASE_URL}/kantor/lock-unlock`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getHakAkses() {
  try {
    const url = `${BASE_URL}/hak-akses/get-all`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function updateHakAkses(data) {
  try {
    const url = `${BASE_URL}/auth/hak-akses`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadPengurusPusat() {
  try {
    const url = `${BASE_URL}/pengurus/pusat/download`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadPengurusProvinsi(order_by, order_type, id_provinsi) {
  try {
    const url = `${BASE_URL}/pengurus/provinsi/download?order_by=${order_by}&order_type=${order_type}&id_provinsi=${id_provinsi}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadPengurusKabkot(
  order_by,
  order_type,
  id_provinsi,
  id_kabkot,
) {
  try {
    const url = `${BASE_URL}/pengurus/kota-kabupaten/download?order_by=${order_by}&order_type=${order_type}&id_provinsi=${id_provinsi}&id_kabkot=${id_kabkot}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadPengurusKecamatan(
  order_by,
  order_type,
  id_provinsi,
  id_kabkot,
) {
  try {
    const url = `${BASE_URL}/pengurus/kecamatan/download?order_by=${order_by}&order_type=${order_type}&id_provinsi=${id_provinsi}&id_kabkot=${id_kabkot}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadRekapPengurusPusat() {
  try {
    const url = `${BASE_URL}/pengurus/pusat/jumlah/download`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadRekapPengurusProvinsi() {
  try {
    const url = `${BASE_URL}/pengurus/provinsi/jumlah/download`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadRekapPengurusKabkot() {
  try {
    const url = `${BASE_URL}/pengurus/kota-kabupaten/jumlah/download`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadRekapAnggota(
  order_by,
  order_type,
  id_provinsi,
  id_kabkot,
) {
  try {
    const url = `${BASE_URL}/list-register/count/download?order_by=${order_by}&order_type=${order_type}&id_provinsi=${id_provinsi}&id_kabkot=${id_kabkot}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getDownloadDaftarAnggota(
  order_by,
  order_type,
  id_provinsi,
  id_kabkot,
) {
  try {
    const url = `${BASE_URL}/list-register/kota-kabupaten/download?order_by=${order_by}&order_type=${order_type}&id_provinsi=${id_provinsi}&id_kabkot=${id_kabkot}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getBank() {
  try {
    const url = `${BASE_URL}/bank/get-all`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

//OVERVIEW
async function getOverviewProvinsi(anggota) {
  try {
    const url = `${BASE_URL}/overview/provinsi?anggota=${anggota}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
async function getOverviewKabkot(anggota) {
  try {
    const url = `${BASE_URL}/overview/kota-kabupaten?anggota=${anggota}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
async function getOverviewKecamatan(anggota, id_provinsi) {
  try {
    let params = "";
    if (id_provinsi) {
      params = params + `&id_provinsi=${id_provinsi}`;
    }
    const url = `${BASE_URL}/overview/kecamatan?anggota=${anggota}${params}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
async function getOverviewKelurahan(anggota) {
  try {
    const url = `${BASE_URL}/overview/kelurahan?anggota=${anggota}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getOverviewRtRw(anggota) {
  try {
    const url = `${BASE_URL}/overview/rt-rw?anggota=${anggota}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

async function getOverviewKomisarisBasis(anggota) {
  try {
    const url = `${BASE_URL}/overview/komisaris-basis?anggota=${anggota}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "GET",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// UPLOAD DOCUMENT
async function uploadDocumentPengurus(data) {
  try {
    const url = `${BASE_URL}/pengurus/upload`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DELETE DOCUMENT
async function deleteDocumentPengurus(id) {
  try {
    const url = `${BASE_URL}/pengurus/delete-doc/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "DELETE",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// DOWNLOAD DOCUMENT
async function downloadDocumentPengurus(id) {
  try {
    const url = `${BASE_URL}/pengurus/download/${id}`;
    const authorization = "Bearer " + loadAuthToken();
    const headers = {
      defaultHeaders,
      authorization,
    };
    const response = await axios({
      method: "POST",
      url,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// get Exco puk
async function getExcoPUK(params) {
  try {
    const url = `${BASE_URL}/kantor/puk-industri`;
    const headers = {
      ...defaultHeaders,
      Authorization: `Bearer ${loadAuthToken()}`,
    };
    const response = await axios({
      method: "GET",
      url,
      params,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// create exco puk
async function createExcoPUK(data) {
  try {
    const url = `${BASE_URL}/kantor/create-puk-industri`;
    const headers = {
      ...defaultHeaders,
      Authorization: `Bearer ${loadAuthToken()}`,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}

// create exco rt rw
async function createExcoRTRW(data) {
  try {
    const url = `${BASE_URL}/kantor/create-rt-rw`;
    const headers = {
      ...defaultHeaders,
      Authorization: `Bearer ${loadAuthToken()}`,
    };
    const response = await axios({
      method: "POST",
      url,
      data,
      headers,
    });
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
}
